import { createSelector } from 'reselect';
const customersStateSelector = ({ entities: { customers } = {} }) => customers;

export const getCustomer = createSelector(
  [customersStateSelector, (_, { id }) => id],
  (customers, id) => {
    return (customers || {})[id];
  }
);



// WEBPACK FOOTER //
// ./src/App/account/selectors/customers/index.js